var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"area"},[_c('div',{staticClass:"flex-grow flex-box vertical align-center"},[_c('h2',{staticClass:"not-found"},[_vm._v("404 页面不存在")]),_c('router-link',{staticClass:"back-home",attrs:{"to":{name: 'Home'},"replace":""}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }